export { default } from './toImmutable'
